import {productConfig} from '@/lib/productConfig';
export default function useMonetization(){return productConfig.peopleMonetizationEnabled;}
